import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const EMAIL_ADDRESS_FETCH = createAsyncActionTypes('EMAIL_ADDRESS_FETCH');